import React from 'react';

const DescriptionSection = ({ value, onChange }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">
        Detailed Description <span className="text-red-500">*</span>
      </h3>
      <textarea
        value={value}
        onChange={(e) => onChange(e?.target?.value)}
        placeholder="Provide a comprehensive description of the unsafe act or condition observed. Include what was happening, specific behaviors or conditions noted, and any relevant context..."
        className="w-full px-4 py-3 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary resize-none"
        rows={6}
        required
      />
      <p className="text-sm text-muted-foreground mt-2">
        {value?.length || 0} characters
      </p>
    </div>
  );
};

export default DescriptionSection;